import { createContext } from 'react';

export const InitialState = {
  startGenerateActivityReportJob: () => {},
  clearJobId: () => {},
  jobId: null,
  filename: null,
  url: null,
  message: null,
  loading: false,
  jobErrors: []
};

export const GenerateActivityReportJobContext = createContext(InitialState);

GenerateActivityReportJobContext.displayName = 'GenerateActivityReportJobContext';
